/** Metrics refresh timeout, in milliseconds */
export const METRICS_REFRESH_TIMEOUT = 60 * 1000;
